// @ts-ignore untyped dependency
import { useEmbedContext } from '../../hooks/useEmbedContext';
// @ts-ignore untyped dependency
import UsageViewTracker from '../../components/tracking/UsageViewTracker';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import { Text } from 'foundations-components/components/Text';
import { H1 } from 'foundations-components/transitional/components/H1';
import CanonicalLink from 'marketplace-ui-common/components/elements/CanonicalLink';
import HrefLangLink from 'marketplace-ui-common/components/elements/HrefLangLink';
import MetaDescription from 'marketplace-ui-common/components/elements/MetaDescription';
import MetaOpenGraph from 'marketplace-ui-common/components/elements/MetaOpenGraph';
import MetaTwitter from 'marketplace-ui-common/components/elements/MetaTwitter';
import DocumentHead from 'marketplace-ui-common/components/portals/DocumentHead';
import PrerenderReady from 'marketplace-ui-common/components/prerender/PrerenderReady';
import { PUBLIC_LANGUAGES } from 'marketplace-ui-common/constants/Languages';
import MainSection from 'marketplace-ui-common/layout/components/MainSection';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner';
import StorefrontHeader from 'marketplace-ui-common/storefront/components/StorefrontHeader';
import { Fragment, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { NavMarker } from 'react-rhumb';
import { UnifiedBreadcrumbs } from '../../components/breadcrumbs/UnifiedBreadcrumbs';
import BrowseBar from '../../components/storefront/browse/BrowseBar';
import StorefrontSearchBar from '../../components/storefront/search/StorefrontSearchBar';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { useSocialScreenshotUrl } from '../../hooks/useSocialScreenshotUrl';
import { PublicOnly } from '../../selectors/app';
import { getFullTemplatesPublicUrl } from '../../utils/urls';
import CalloutsSection from '../components/CalloutsSection';
import ModulesSection from '../components/ModulesSection';
import ProviderSignupSection from '../components/ProviderSignupSection';
import ThemesSection from '../components/ThemesSection';
import VideoSection from '../components/VideoSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TemplatesHomeContainer() {
  const {
    isEmbedded
  } = useEmbedContext();
  const lang = getLang();
  const canonicalUrl = getFullTemplatesPublicUrl(lang);
  const metaDescription = unescapedText('marketplace-assets-ui.templates.metaDescription');
  const [isSticky, setIsSticky] = useState(false);
  const [pageActive, setPageActive] = useState(false);
  const renderedHrefLangLinks = useMemo(() => {
    const hrefLangConfigs = [{
      href: getFullTemplatesPublicUrl('en'),
      isDefault: true,
      lang: 'en'
    }, ...PUBLIC_LANGUAGES.map(_lang => ({
      href: getFullTemplatesPublicUrl(_lang),
      isDefault: false,
      lang: _lang
    }))];
    return hrefLangConfigs.map(({
      href,
      isDefault,
      lang: _lang
    }) => /*#__PURE__*/_jsx(HrefLangLink, {
      href: href,
      lang: _lang,
      "x-default": isDefault
    }, `href-lang-${isDefault ? 'default' : _lang}`));
  }, []);
  const onStickyChange = useCallback(evt => {
    setIsSticky(evt.target.value);
  }, []);
  const {
    trackInteraction,
    trackPageview,
    setDefaultEventProperties
  } = useContext(StorefrontUsageTrackerContext);
  useEffect(() => {
    setDefaultEventProperties({
      screen: 'templates homepage'
    });
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setPageActive(true);
  }, [setDefaultEventProperties]);
  useEffect(() => {
    document.title = I18n.text('marketplace-assets-ui.templates.htmlTitle');
  }, []);
  const socialScreenshotUrl = useSocialScreenshotUrl();
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "TEMPLATES_LOAD",
    children: [/*#__PURE__*/_jsx(PublicOnly, {
      children: /*#__PURE__*/_jsx(DocumentHead, {
        children: /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(MetaDescription, {
            content: metaDescription
          }), /*#__PURE__*/_jsx(MetaTwitter, {
            name: "card"
          }), /*#__PURE__*/_jsx(MetaTwitter, {
            name: "site"
          }), /*#__PURE__*/_jsx(MetaTwitter, {
            name: "image",
            content: socialScreenshotUrl
          }), /*#__PURE__*/_jsx(MetaOpenGraph, {
            property: "type"
          }), /*#__PURE__*/_jsx(MetaOpenGraph, {
            property: "url",
            content: canonicalUrl
          }), /*#__PURE__*/_jsx(MetaOpenGraph, {
            property: "description",
            content: metaDescription
          }), /*#__PURE__*/_jsx(MetaOpenGraph, {
            property: "image",
            content: socialScreenshotUrl
          }), /*#__PURE__*/_jsx(CanonicalLink, {
            href: canonicalUrl
          }), renderedHrefLangLinks, /*#__PURE__*/_jsx(PrerenderReady, {})]
        })
      })
    }), /*#__PURE__*/_jsxs("main", {
      children: [/*#__PURE__*/_jsx(StorefrontHeader, {
        collapsedTitle: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.templates.header.stickyTitle"
        }),
        color: "white",
        compact: isEmbedded,
        subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.header.subtitle"
        }),
        title: /*#__PURE__*/_jsx(H1, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.storefront.header.title"
          })
        }),
        onStickyChange: onStickyChange,
        use: "default",
        renderBreadcrumbsInTitle: true,
        renderedBreadcrumbs: /*#__PURE__*/_jsx(UnifiedBreadcrumbs, {
          path: "templates-home"
        }),
        children: /*#__PURE__*/_jsx(StorefrontSearchBar, {
          isSticky: isSticky
        })
      }), /*#__PURE__*/_jsx(BrowseBar, {
        hasActiveOfferingType: false
      }), /*#__PURE__*/_jsx(MainSection, {
        color: "light",
        children: /*#__PURE__*/_jsxs(MainSectionInner, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h2",
            typography: "heading-600",
            textAlign: "center",
            paddingBlockStart: "500",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.templates.video.title"
            })
          }), /*#__PURE__*/_jsx(Text, {
            as: "h3",
            typography: "heading-500",
            textAlign: "center",
            marginBlockEnd: "1000",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.templates.video.subtitle"
            })
          }), /*#__PURE__*/_jsx(VideoSection, {}), /*#__PURE__*/_jsx(CalloutsSection, {
            onTrackInteraction: trackInteraction
          })]
        })
      }), /*#__PURE__*/_jsx(MainSection, {
        color: "light",
        paddingInline: "0",
        children: /*#__PURE__*/_jsx(MainSectionInner, {
          children: /*#__PURE__*/_jsx(ThemesSection, {
            onTrackInteraction: trackInteraction
          })
        })
      }), /*#__PURE__*/_jsx(MainSection, {
        paddingInline: "0",
        children: /*#__PURE__*/_jsx(MainSectionInner, {
          children: /*#__PURE__*/_jsx(ModulesSection, {
            onTrackInteraction: trackInteraction
          })
        })
      }), /*#__PURE__*/_jsx(MainSection, {
        color: "light",
        padding: "0",
        children: /*#__PURE__*/_jsx(MainSectionInner, {
          children: /*#__PURE__*/_jsx(ProviderSignupSection, {
            onTrackInteraction: trackInteraction
          })
        })
      })]
    }), /*#__PURE__*/_jsx(UsageViewTracker, {
      active: pageActive,
      onTrackView: trackPageview
    })]
  });
}